import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { ConsentFormPage } from 'src/modules/auth/screens/ConsentFormPage';
import { ClickwrapConsentForm } from 'src/modules/auth/screens/ClickwrapConsentForm';

export const ConsentFormContainer = props => {
    const flags = useFlags();

    if (flags.fdrEnableClickwrapConsentsWebRelease) {
        return <ClickwrapConsentForm />;
    }

    return <ConsentFormPage {...props} />;
};
